// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2o0pe","legacyBtn":"MutateMid_legacyBtn__5aX3K"};